import TicketCessionController from './ticket.cession.controller';

export default {
    template: require('./ticket.cession.html'),
    controller: TicketCessionController
};